import Clarity from '@microsoft/clarity'

let gTag: string | undefined
let clarityProjectId: string | undefined

const analyticsSettings = {
  isMicrosoftClarityEnabled: true,
  isGoogleAnalyticsEnabled: true,
}

function loadScript(src: string) {
  const script = document.createElement('script')
  script.async = true
  script.src = src
  document.head.appendChild(script)
}

function initGoogleAnalytics() {
  gTag = import.meta.env.VITE_GTAG_ID
  if (gTag) {
    loadScript(`https://www.googletagmanager.com/gtag/js?id=${gTag}`)
    window.dataLayer = window.dataLayer || []
    window.gtag = function () {
      window.dataLayer.push(arguments)
    }
    window.gtag('js', new Date())
    window.gtag('config', gTag, {
      cookie_flags: 'SameSite=None;Secure',
    })
  }
}

function initClarity() {
  clarityProjectId = import.meta.env.VITE_CLARITY_PROJECT_ID
  if (clarityProjectId) {
    Clarity.init(clarityProjectId)
  }
}

export function init(webPlayInfo: Record<string, unknown>, urlParams: URLSearchParams) {
  const suppressAnalytics = urlParams.has('nostats')
  analyticsSettings.isMicrosoftClarityEnabled = !suppressAnalytics && !!webPlayInfo.isMicrosoftClarityEnabled
  analyticsSettings.isGoogleAnalyticsEnabled = !suppressAnalytics && !!webPlayInfo.isGoogleAnalyticsEnabled

  if (analyticsSettings.isGoogleAnalyticsEnabled) {
    initGoogleAnalytics()
  }
  if (analyticsSettings.isMicrosoftClarityEnabled) {
    initClarity()
  }
}

export function track(event: string, data: Record<string, unknown>) {
  if (analyticsSettings.isGoogleAnalyticsEnabled && gTag) {
    window.gtag('event', event, data)
  }
  if (analyticsSettings.isMicrosoftClarityEnabled && clarityProjectId) {
    Clarity.event(event)
  }
}
